import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Slug do catálogo de permissões — o mesmo que protege a rota no backend. */
  permissao?: string;
  modulo?: string;
}

/**
 * Guarda de rota client-side: é conforto, não segurança. A fronteira real é o
 * middleware `pode:` do backend, revalidado a cada requisição. Aqui a lista de
 * permissões vem pronta de /api/me — a tela nunca deduz acesso a partir do
 * papel, que é justamente onde menu e rota costumam divergir.
 */
export function ProtectedRoute({ children, permissao, modulo }: ProtectedRouteProps) {
  const { user, isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.trocar_senha && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }

  if (modulo && !(user?.modulos_ativos ?? []).includes(modulo)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  if (permissao && !(user?.permissoes ?? []).includes(permissao)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return <>{children}</>;
}
